module.exports = __webpack_public_path__ + "img/bg-2.7a76e9ed.jpg";